export var AbortedReason;
(function (AbortedReason) {
    AbortedReason[AbortedReason["UNKNOWN"] = 0] = "UNKNOWN";
    AbortedReason[AbortedReason["NO_ANSWER"] = 1] = "NO_ANSWER";
    AbortedReason[AbortedReason["MIC_ACCESS"] = 2] = "MIC_ACCESS";
    AbortedReason[AbortedReason["PORT"] = 4] = "PORT";
    AbortedReason[AbortedReason["INVALID_NUMBER"] = 5] = "INVALID_NUMBER";
    AbortedReason[AbortedReason["HANGED_UP"] = 6] = "HANGED_UP";
    AbortedReason[AbortedReason["INCOMING_INVITE_DECLINED"] = 7] = "INCOMING_INVITE_DECLINED";
    AbortedReason[AbortedReason["INCOMING_NO_ANSWER"] = 8] = "INCOMING_NO_ANSWER";
    AbortedReason[AbortedReason["DISCONNECT"] = 10] = "DISCONNECT";
    AbortedReason[AbortedReason["DEVICE_ACCESS_DENIED"] = 11] = "DEVICE_ACCESS_DENIED";
})(AbortedReason || (AbortedReason = {}));
//# sourceMappingURL=phone.js.map